import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
  find,
} from 'lodash';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import {css} from 'aphrodite';

import {
  getDynamicCoverageList,
  getDynamicCoverageStateProfiles,
  setDynamicCoverageShowAlert,
  ERROR_ALERT,
  NO_ROW_ALERT,
} from 'actions/dynamicCoverage';

import {
  getError,
  getInProgress,
  getShowErrorAlert,
  getShowNoRowsAlert,
  getStateCoverageProfiles,
} from 'selectors/dynamicCoverage';

import {
  filterForMapStates,
} from 'libs/salmon-utils';

import {getSettings} from 'selectors/settings';

import {getErrorField, hasClass} from 'libs/react-widgets';
import TabularDataBasic from 'components/TabularDataBasic';
import USMap, {USStates} from 'components/USMap';
import Markdown from 'components/Markdown';
import Isi from 'components/Isi';
import ErrorAlert from 'components/ErrorAlert';
import StateCoverageProfileDocumentDownload from 'components/StateCoverageProfileDocumentDownload';
import CoverageFilters from './Filters';
import {applyDynamicFilters, resolveFieldValueFromMap, getFieldNameKey} from './Filters/utils';
import {
  buildUrlParameters,
  parseUrlParameters,
  updateBrowserUrl,
} from './Filters/url';
import TableFooter from './TableFooter';
import Loader from 'components/Loader';
import './styles.scss';
import {ButtonGroup} from '../Coverage/ButtonGroup';
import {getDynamicCoverageColumns} from './table-formatter';
import {filterStateValueBySelection, isStateColumn} from './Filters/utils';
import * as track from '../../services/analytics/tracking';

// TODO: refactor this class to functional component
export class DynamicCoverage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedStates: [],
      selectedPlanTypes: [],
      selectedDynamicFilters: {},
      results: false,
      hasSearched: false,
      showInstruction: true,
      urlParameters: parseUrlParameters(),
    };

    this._filterCoverage = this._filterCoverage.bind(this);
    this._handleUSMapClick = this._handleUSMapClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // Only handle results flag computation here
    // Dropdown selection logic moved to CoverageFilters

    // Check if selectedX values changed
    const selectedFiltersChanged =
      JSON.stringify(this.state.selectedStates) !== JSON.stringify(prevState.selectedStates) ||
      JSON.stringify(this.state.selectedPlanTypes) !== JSON.stringify(prevState.selectedPlanTypes) ||
      JSON.stringify(this.state.selectedDynamicFilters) !== JSON.stringify(prevState.selectedDynamicFilters);

    // If URL params exist and selections changed, compute results flag
    if (selectedFiltersChanged && Object.keys(this.state.urlParameters).length > 0) {
      // Compute results based on whether any filters have valid selections
      const hasValidSelections =
        this.state.selectedStates.length > 0 ||
        this.state.selectedPlanTypes.length > 0 ||
        Object.values(this.state.selectedDynamicFilters || {}).some((arr) => arr.length > 0);

      this.setState({
        results: hasValidSelections
      });
    }

    //=========== Enhanced GA Tracking ============
    //Event 1: pals_filters_apply – track after table finishes rendering
    if (!prevState.hasSearched && this.state.hasSearched && this.state.results) {
      const resultsCount = this._lastResultsCount ?? 0;
      track.filtersApply(track.buildFiltersApplyParams(this.state, this.props.settings), resultsCount, this.props.settings.domain);
    }
  }

  componentDidMount() {
    const {
      dispatchGetDynamicCoverageList,
      dispatchGetDynamicCoverageStateProfiles,
      settings,
    } = this.props;

    // don't fetch again if component remounts
    if (this.props.coveragePositions.length === 0) {
      if (settings.domain) {
        dispatchGetDynamicCoverageList(settings.domain, settings.content.searchErrorUnavailable);
        if (settings.stateCoverageProfiles && settings.stateCoverageProfiles.enabled) {
          dispatchGetDynamicCoverageStateProfiles(settings.domain);
        }
      } else if (settings.drugId) {
        dispatchGetDynamicCoverageList(settings.drugId, settings.content.searchErrorUnavailable);
      }
    }
  }

  _handleFilterChange = (filterUpdates) => {
    // Callback from CoverageFilters to update filter state
    // Reset hasSearched flag when filters change, so results won't show until Search is clicked again
    this.setState({
      ...filterUpdates,
      hasSearched: false,
    });
  }

  _handleUrlFiltersUpdate = (selectedFilters) => {
    // Restore filter selections from URL parameters
    // Don't automatically show results - user must click Search button
    this.setState({
      ...selectedFilters,
      hasSearched: false,
      // Note: results flag may be set by componentDidUpdate, but hasSearched prevents display
    });
  }

  _handleMapStateClick(el) {
    const {
      selectedStates,
    } = this.state;

    const currentElement = el.currentTarget;
    const clickedState = find(this.props.usStates, {id: currentElement.id});

    let currentSelectedStates = [...selectedStates];
    if (hasClass(currentElement, 'active')) {
      currentSelectedStates = currentSelectedStates.filter(
        (state) => state.id !== currentElement.id
      );
    } else {
      currentSelectedStates = [...currentSelectedStates, clickedState];
    }

    this.setState({
      selectedStates: currentSelectedStates,
      hasSearched: false,
    });
  }

  _filterCoverage() {
    const {
      settings,
    } = this.props;

    // Update browser url parameters.
    const newUrlParameters = buildUrlParameters(
      this.state,
      settings.filterLayout,
      settings.urlParametersMap
    );
    updateBrowserUrl(newUrlParameters);

    // Note: filteredX values are no longer stored in state - they are computed
    // dynamically from selectedX values in the render() method
    this.setState({
      results: true,
      hasSearched: true,
      showInstruction: settings.content.alwaysShowInstruction,
      urlParameters: newUrlParameters,
    }, () => {
      this._setAlert(NO_ROW_ALERT, true);
      if (this.props.settings.jumpToResultsAfterSearching) {
        document.getElementById('results').scrollIntoView();
      }
    });
  }
  _setAlert(type, value) {
    this.props.dispatchSetDynamicCoverageShowAlert({
      type,
      value,
    });
  }

  _handleUSMapClick(el) {
    const {
      selectedStates,
    } = this.state;

    const currentElement = el.currentTarget;
    let include = !hasClass(currentElement, 'active');

    let currentSelectedStates = filterForMapStates(selectedStates, currentElement.id, include, USStates);

    this.setState({
      selectedStates: currentSelectedStates,
      hasSearched: false,
    });
  }

  render() {
    const {
      selectedStates,
      selectedPlanTypes,
      results,
      hasSearched,
      showInstruction,
    } = this.state;

    const {
      inProgress,
      planTypes,
      coveragePositions,
      settings,
      styleSheet,
      error,
      showErrorAlert,
      showNoRowsAlert,
      stateCoverageProfiles,
    } = this.props;
    let tableRows = [];

    if (results && hasSearched && this.props.usStates.length > 0) {
      let filteredPositions = coveragePositions;
      // Apply dynamic column filters if dynamicColumns enabled
      filteredPositions = applyDynamicFilters(
        filteredPositions,
        this.state.selectedDynamicFilters || {},
        settings
      );

      if (selectedStates.length > 0) {
        const selectedStateIds = new Set(
          selectedStates
            .map((s) => s?.id)
            .filter((id) => id != null && id !== '')
        );
        if (selectedStateIds.size > 0) {
          filteredPositions = filteredPositions.filter((pos) => {
            const statesField = pos.fields?.find((f) => f.fieldName === 'states' || f.fieldName === 'state');
            const posStates = Array.isArray(statesField?.value) ? statesField.value : [];
            return posStates.some((s) => selectedStateIds.has(String(s)));
          });
        }
      }
      if (selectedPlanTypes.length > 0) {
        const selectedLabels = new Set(
          selectedPlanTypes
            .map((p) => p?.label ?? p?.name)
            .filter((l) => l != null && l !== '')
        );
        if (selectedLabels.size > 0) {
          filteredPositions = filteredPositions.filter((pos) => {
            const ptField = pos.fields?.find((f) => f.fieldName === 'planType' || f.fieldName === 'rxPlanType');
            const posPlanType = ptField?.value;
            return posPlanType && selectedLabels.has(String(posPlanType));
          });
        }
      }

      let row;

      filteredPositions.forEach((position) => {
        row = {};
        // ============Dynamic columns start============
        // Map dynamic fields from position.fields array to row data
        if (position.fields && Array.isArray(position.fields)) {
          // Add the fields array to rowData for access to full field structure
          row.fields = position.fields;

          // Build a lookup map of fieldName -> value from position.fields
          const fieldsMap = {};
          position.fields.forEach((field) => {
            if (field.fieldName && field.value !== undefined && field.value !== null) {
              fieldsMap[field.fieldName] = field.value;
            }
          });

          // Map dynamic fields to row based on column properties
          settings.table.columns.forEach((column) => {
            const property = column.property;
            if (row.hasOwnProperty(property)) {
              return; // static field already set
            }

            let value = resolveFieldValueFromMap(
              fieldsMap,
              property,
              column.fieldName
            );
            if (value !== undefined) {
              if (isStateColumn(column) && selectedStates.length > 0) {
                value = filterStateValueBySelection(value, selectedStates);
              }
              row[property] = value;
            }
          });
        }
        // ============Dynamic columns end============
        tableRows.push(row);
      });
    }

    this._lastResultsCount = tableRows.length;

    const tableColumns = getDynamicCoverageColumns({
      props: this.props,
    });

    const tableFooter = (
      <TableFooter
        footerColSpan={tableColumns.length}
        styleSheet={styleSheet}
        selectedProductId={settings.drugId}
        disclaimerTemplate={settings.content.tableDisclaimerExpanded.markdown}
      />
    );

    /**
     * TODO: Remove planTypes from CoverageFilters props.
     */
    const filterInputs = (
      <CoverageFilters
        planTypes={planTypes}
        selectedStates={selectedStates}
        selectedPlanTypes={selectedPlanTypes}
        selectedDynamicFilters={this.state.selectedDynamicFilters || {}}
        inProgress={inProgress}
        settings={settings}
        styleSheet={styleSheet}
        urlParameters={this.state.urlParameters}
        onUrlFiltersUpdate={this._handleUrlFiltersUpdate}
        onFilterChange={this._handleFilterChange}
      />
    );

    /*
     * TODO: replace modalSuccess with buttonPrimary for the shared search button style
     * should be like this:
     * const searchButtonStyle = css(styleSheet.buttonPrimary, styleSheet.searchButton);
     * https://github.com/PolicyReporter/requests/issues/18118
     */
    const searchButtonStyle = css(styleSheet.buttonPrimary, styleSheet.modalSuccess, styleSheet.searchButton);
    // Disable Search if any dynamic filter marked required has no selection.
    // Mirrors imfinziimjudo's required-field pattern but applied to dynamic filters
    // so PALs like saphnelo can enforce a mandatory product selection before searching.
    const requiredDynamicFilters = (settings.filterLayout || [])
      .filter((col) => col.filter === 'dynamic' && col.required);
    const hasRequiredUnfilled = requiredDynamicFilters.some((col) => {
      const key = getFieldNameKey(col.fieldName);
      return (this.state.selectedDynamicFilters?.[key] || []).length === 0;
    });
    const isSearchButtonDisabled = inProgress || hasRequiredUnfilled;

    return (
      <div data-component={'Coverage'}>
        <Loader isFetching={inProgress} isFullscreen/>

        <Container>
          <Row>
            {Boolean(settings.banner.enabled) &&
            <Col xs={12} className={css(styleSheet.banner)}>
              { Boolean(settings.banner.content.html) &&
                <div dangerouslySetInnerHTML={{__html: settings.banner.content.html}} />
              }
            </Col>
            }
          </Row>
          <Row>
            {
              settings.content.searchPreface &&
              <div className={`searchPreface ${css(styleSheet.searchPreface)}`}>
                <Markdown>{settings.content.searchPreface}</Markdown>
              </div>
            }
            {
              showInstruction &&
              <div className={`instruction ${css(styleSheet.initialSearchInstruction)}`}>
                <Markdown>
                  {settings.content.initialSearchInstruction}
                </Markdown>
              </div>
            }
            <ErrorAlert error={getErrorField('global', 'global', error)} alertVisible={showErrorAlert} handleDismissAlert={this._setAlert.bind(this, ERROR_ALERT, false)}/>
          </Row>
          {!settings.searchCoverageFunctionality.disabled &&
            <React.Fragment>
              {filterInputs}
              {!results && settings.content.underFiltersText?.markdown &&
                <div>
                  <Row>
                    <Col>
                      <div className={css(styleSheet.underFiltersText)}>
                        <Markdown>{settings.content.underFiltersText.markdown}</Markdown>
                      </div>
                    </Col>
                  </Row>
                </div>
              }
              <Row className={'text-center'}>
                <Col className="w-auto mx-auto">
                  <Button
                    type={'submit'}
                    className={ isSearchButtonDisabled ? `${searchButtonStyle} disabled` : searchButtonStyle }
                    disabled={ isSearchButtonDisabled }
                    onClick={ this._filterCoverage }
                  >
                  Search
                  </Button>
                </Col>
              </Row>
            </React.Fragment>
          }
          {settings.usRegionalMap &&
            <Row>
              <Col className='p-0'>
                <USMap
                  handleStateClick={this._handleUSMapClick}
                  selectedStates={selectedStates}
                />
              </Col>
            </Row>
          }

          {showInstruction &&
            <Row className={css(styleSheet.initialSupplementalInstruction)}>
              <Markdown>
                {settings.content.initialSupplementalInstruction.markdown}
              </Markdown>
            </Row>
          }
          {results && hasSearched &&
            <Row className={css(styleSheet.results)} id='results'>
              {(!inProgress && tableRows.length === 0 && showNoRowsAlert) &&
                <Row className='p-0 m-0'>
                  <Alert variant={'warning'} dismissible onClose={this._setAlert.bind(this, NO_ROW_ALERT, false)}>
                    <Markdown>{settings.content.tableErrorNoResult}</Markdown>
                  </Alert>
                </Row>
              }
              {(settings.stateCoverageProfiles?.enabled && stateCoverageProfiles.length > 0) &&
                <StateCoverageProfileDocumentDownload
                  settings={settings}
                  styleSheet={styleSheet}
                  stateCoverageProfiles={stateCoverageProfiles}
                />
              }
              {tableRows.length > 0 &&
                <div className='p-0'>
                  <Row>
                    <div className={`${css(styleSheet.footNote)} p-0`}>
                      <Markdown>{settings.content.tableDisclaimerShort.markdown}</Markdown>
                    </div>
                  </Row>
                  <Row>
                    <div className={`${css(styleSheet.dataTable)} p-0`}>
                      <TabularDataBasic
                        data={tableRows}
                        columns={tableColumns}
                        customFooter={tableFooter}
                        onPageChangeCallback={() => document.getElementById('results').scrollIntoView({behavior: settings.styles.page.scrollBehavior})}
                        renderToolbar={
                          settings.table.buttons?.length > 0
                            ? (visibleRows) => (
                              <ButtonGroup
                                buttons={settings.table.buttons}
                                data={visibleRows}
                                styleSheet={styleSheet}
                                settings={settings}
                                filterState={this.state}
                              />
                            )
                            : undefined
                        }
                      />
                    </div>
                  </Row>
                </div>
              }
              {settings.content.underResultsText &&
                <div>
                  <Row>
                    <Col>
                      <div className={css(styleSheet.underResultsText)}>
                        <Markdown>{settings.content.underResultsText.markdown}</Markdown>
                      </div>
                    </Col>
                  </Row>
                </div>
              }
            </Row>
          }
          <Isi settings={settings.isi} styleSheet={styleSheet}/>
          {settings.content.bottomSection &&
            <Row><div className={css(styleSheet.bottomSection)}>
              <Markdown>{settings.content.bottomSection.markdown}</Markdown>
            </div></Row>
          }
        </Container>
      </div>
    );
  }
}

DynamicCoverage.propTypes = {
  dispatchGetDynamicCoverageList: PropTypes.func.isRequired,
  dispatchGetDynamicCoverageStateProfiles: PropTypes.func.isRequired,
  dispatchSetDynamicCoverageShowAlert: PropTypes.func.isRequired,
  coveragePositions: PropTypes.array.isRequired,
  stateCoverageProfiles: PropTypes.array.isRequired,
  usStates: PropTypes.array.isRequired,
  planTypes: PropTypes.array.isRequired,
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
    PropTypes.string,
  ]),
  showErrorAlert: PropTypes.bool.isRequired,
  showNoRowsAlert: PropTypes.bool.isRequired,
};

const mapStateToProps = function (state) {
  const {
    dynamicCoverage,
  } = state;

  return {
    coveragePositions: dynamicCoverage.get('coveragePositions').toJS(),
    stateCoverageProfiles: getStateCoverageProfiles(state),
    usStates: dynamicCoverage.get('states').toJS(),
    planTypes: dynamicCoverage.get('planTypes').toJS(),
    error: getError(state),
    inProgress: getInProgress(state),
    settings: getSettings(state),
    showErrorAlert: getShowErrorAlert(state),
    showNoRowsAlert: getShowNoRowsAlert(state),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    dispatchGetDynamicCoverageList: (...args) => {
      dispatch(getDynamicCoverageList(...args));
    },
    dispatchGetDynamicCoverageStateProfiles: (...args) => {
      dispatch(getDynamicCoverageStateProfiles(...args));
    },
    dispatchSetDynamicCoverageShowAlert: (...args) => {
      dispatch(setDynamicCoverageShowAlert(...args));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicCoverage);

// Re-export helper functions for backward compatibility
export {restrictPayers, extractPbms} from '../Coverage/Filters/utils';
